import request from 'api/requestUtils'
import qs from 'qs'

export function getTrendingDestinations(regionCode: string, leUserId?: string, domainUserId?: string, disablePersonalisation?: boolean) {
  const params = {
    region: regionCode,
    le_user_id: leUserId,
    disable_personalisation: disablePersonalisation,
    domain_user_id: domainUserId,
    limit: 15,
  }
  return request.get<App.ApiResponse<Array<App.TrendingDestination>>>(`/api/search/hotel/v2/places/trending?${qs.stringify(params)}`)
    .then(res => res.result)
}

export function getHotelPopularHolidayTypes(regionCode: string) {
  return request.get<App.ApiResponse<Array<{ name: string }>>>(`/api/search/hotel/v1/popular/holiday-types?region=${regionCode}&limit=7`)
    .then(res => res.result)
}
